import { useCallback, useState, useEffect } from 'react';

export enum EnumWithdrwalStage {
  ConfirmPassword = 'confirm-password',
  ConfirmChat = 'confirm-chat',
  Membership = 'confirm-membership',
  Complete = 'complete'
}

export type WithdrwalStage =
  | 'confirm-password'
  | 'confirm-membership'
  | 'confirm-chat'
  | 'complete';

const useWithdrawalStage = (): [
  WithdrwalStage,
  (stage: WithdrwalStage) => void
] => {
  const [stage, setStage] = useState<WithdrwalStage>(
    EnumWithdrwalStage.ConfirmPassword
  );

  const onChange = useCallback((stage: WithdrwalStage) => setStage(stage), []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [stage]);

  return [stage, onChange];
};

export default useWithdrawalStage;
